/**
 * @description
 * @author Kody
 * @date 2018-07-03
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import IInput from './models/input';
import IOutput from './models/output';

export type DoFollowInput = IInput;
export const toogleFllowTeacher = (data: IInput): Promise<IOutput> => {
    const url = data.is_follow ? Api.ADD_FLLOW : Api.DELETE_FLLOW;
    const param: Omit<IInput, 'is_follow'> = {
        famous_id: data.famous_id,
        type: 'teacher',
    };
    if (data.scene_id && data.scene_type) {
        param.scene_id = data.scene_id;
        param.scene_type = data.scene_type;
    }
    return fetchData(url, param).then((res: IOutput) => {
        return res;
    });
};
